import type { EditControlProps } from '../../declare'
import { Input } from 'antd'

const TextInput = (props: EditControlProps) => {
  const handleChange = (evt: any) => {
    props.onChange?.(evt.target.value)
  }

  const { __READONLY__, EDITABLE, PROMPT_INFO, LABEL_TAIL } = props.config
  return (
    <Input
      disabled={__READONLY__ || !EDITABLE || props.evtConfig?.disabled}
      placeholder={PROMPT_INFO}
      value={props.value}
      addonAfter={LABEL_TAIL}
      onChange={handleChange}
    />
  )
}

export default TextInput